import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, IconButton, Tooltip, Button, Typography, Switch, Grid } from "@mui/material";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { styled } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const IOSSwitch = styled(Switch)(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#4CAF50",
        opacity: 1,
      },
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.5,
    },
  },
  "& .MuiSwitch-thumb": {
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: "#F44336",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 300,
    }),
  },
}));

const HierarchyTable = ({ title, data, showActions, handleSeeHierarchy, toggleUserStatus, togglePayoutStatus, handleBack }) => {
  return (
    <Box>
      <Typography variant="h6" sx={{ marginBottom: 2 }}>{title}</Typography>
      <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3, overflowX: "auto" }}>
        <Table>
          <TableHead sx={{ backgroundColor: "#027BFE" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>Sr No.</TableCell>
              <TableCell sx={{ color: "white" }}>Name</TableCell>
              <TableCell sx={{ color: "white" }}>User ID</TableCell>
              <TableCell sx={{ color: "white" }}>User Role</TableCell>
              <TableCell sx={{ color: "white" }}>Business Name</TableCell>
              <TableCell sx={{ color: "white" }}>Mobile</TableCell>
              <TableCell sx={{ color: "white" }}>PayIn Service</TableCell>
              <TableCell sx={{ color: "white" }}>Wallet Balance</TableCell>

              {showActions && <TableCell sx={{ color: "white" }}>PayOut Service</TableCell>}
              {showActions && <TableCell sx={{ color: "white" }}>User Status</TableCell>}
              {showActions && <TableCell sx={{ color: "white" }}>Action</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length > 0 ? (
              data.map((row, index) => (
                <TableRow key={index} sx={{ backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#C1E0FB" }}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.userName}</TableCell>
                  <TableCell>{row.userId}</TableCell>
                  <TableCell>{row.userRole}</TableCell>
                  <TableCell>{row.userBusinessName || "N/A"}</TableCell>
                  <TableCell>{row.userContactNo || "N/A"}</TableCell>
                  <TableCell>{row.userPayinStatus}</TableCell>
                  <TableCell>{Number(row.userWalletBalance).toFixed(2)}</TableCell>
                  {showActions && (
                    <TableCell>
                      <IOSSwitch 
                        checked={row.userPayoutStatus === "ACTIVE"} 
                        onChange={() =>
                            togglePayoutStatus(row.userId, row.userPayoutStatus)
                          }
                        /> 
                    </TableCell>
                  )}
                  {showActions && (
                    <TableCell>
                      <IOSSwitch checked={row.userStatus === "ACTIVE"} onChange={() => toggleUserStatus(row.userId, row.userStatus)} />
                    </TableCell>
                  )}
                  {showActions && (
                    <TableCell>
                      <Tooltip title="See Hierarchy">
                        <IconButton onClick={() => handleSeeHierarchy(row)} sx={{ color: "#4CAF50" }}>
                          <AccountTreeIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={10} align="center">No Data Available</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default HierarchyTable;